import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from 'react-router-dom';
import  ThemeContext  from "./context/ThemeContext"; 
import UserContextProvider from "./context/UserContext";
ReactDOM.render(
                <BrowserRouter>
                    <ThemeContext>
                        <UserContextProvider>
                        <App />

                        </UserContextProvider>
                    </ThemeContext>  
                </BrowserRouter> ,
  document.getElementById("root")
);